import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import React from 'react';
import DropDown from '../../images/policy/dropdown.svg';

export default function WalletMenu({ items, selectedWallet, onChange }) {
  return (
    <Menu
      menuButton={
        <MenuButton>
          <img src={DropDown} alt="" />
          <p className="ml-4px">{selectedWallet.walletName}</p>
        </MenuButton>
      }
      transition
    >
      {items.map((item) => (
        <MenuItem onClick={() => onChange(item)}>{item.walletName}</MenuItem>
      ))}
    </Menu>
  );
}
